import type { PaginatedApiParams } from '~/common/types/api.type';

/**
 * 관리자 역할
 */
export enum AdminRole {
  /** 마스터 */
  MASTER = 0,
  /** 슈퍼 관리자 */
  SUPER_ADMIN = 1,
  /** 관리자 */
  ADMIN = 2,
  /** 영업담당 */
  SALES = 11,
  /** 점주 */
  STORE_OWNER = 21,
  /** 매니저 */
  MANAGER = 22,
}

/**
 * 관리자 요약 정보 (다른 엔티티에서 참조 시 사용)
 * @description Store의 managers, sales 등에서 사용
 */
export interface AdminInfoDto {
  /** 관리자 ID */
  id: number;
  /** 관리자 계정 */
  userId: string;
  /** 관리자 이름 */
  name: string;
}

/**
 * 관리자 소속 지점 정보
 */
export interface AdminStoreDto {
  /** 지점 ID */
  id: number;
  /** 지점 코드 */
  code: string;
  /** 지점명 */
  name: string;
}

/**
 * 관리자 엔티티
 */
export interface Admin {
  id: number;
  userId: string;
  name: string;
  role: AdminRole;
  createdAt: string;
  updatedAt: string;
  stores: AdminStoreDto[];
}

/**
 * 관리자 목록 정렬 키
 */
export type AdminOrderKey = 'id' | 'userId' | 'role' | 'createdAt' | 'updatedAt';

/**
 * 관리자 목록 조회 파라미터
 */
export interface AdminListParams extends PaginatedApiParams<AdminOrderKey> {
  /** 관리자 계정 검색 (부분 일치) */
  userId?: string;
  /** 권한별 필터 (배열) */
  role?: AdminRole[];
  /** 지점 ID 필터 */
  storeId?: number;
}

/**
 * 관리자 생성 요청
 */
export interface AdminCreateRequest {
  userId: string;
  password: string;
  name?: string;
  role: AdminRole;
  storeId?: number;
}

/**
 * 관리자 수정 요청
 */
export interface AdminUpdateRequest {
  userId?: string;
  password?: string;
  name?: string;
  role?: AdminRole;
  storeId?: number;
}

/**
 * 관리자 활성 상태 변경 요청
 */
export interface AdminActiveStatusRequest {
  ids: number[];
  isActive: boolean;
}
